<template>
  <a class="button" :href="link">
    <slot></slot>
    <div class="label">
      {{ label }}
    </div>
  </a>
</template>

<style lang="scss">
.button {
  display: flex;
  align-items: center;
  height: 32px;

  padding-left: 8px;
  padding-right: 8px;

  transition-duration: 250ms;
  transition-property: background-color;
  transition-timing-function: ease-out;

  text-decoration: none;
  border-radius: 5px;

  cursor: pointer;

  .label {
    margin-left: 8px;

    color: white;
    font-family: "Inter";
    font-weight: 700;
  }

  &:hover {
    background-color: #40923c;
  }
}
</style>

<script>
export default {
  name: "HeaderButton",
  props: {
    label: String,
    link: String,
  },
};
</script>
